import { render, staticRenderFns } from "./TravelServiceOrderItemChip.vue?vue&type=template&id=3324371e&"
import script from "./TravelServiceOrderItemChip.vue?vue&type=script&lang=js&"
export * from "./TravelServiceOrderItemChip.vue?vue&type=script&lang=js&"
import style0 from "./TravelServiceOrderItemChip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3324371e')) {
      api.createRecord('3324371e', component.options)
    } else {
      api.reload('3324371e', component.options)
    }
    module.hot.accept("./TravelServiceOrderItemChip.vue?vue&type=template&id=3324371e&", function () {
      api.rerender('3324371e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Chips/TravelServiceOrderItemChip.vue"
export default component.exports